import { useTranslation } from 'react-i18next';
import { Button } from '@attendance/ui';
import {
  FEATURE_DEFAULTS,
  LEAN_ATTENDANCE_FEATURES,
  OFFICE_ONLY_FEATURES,
  TERMINAL_ONLY_FEATURES,
  type FeatureKey,
} from '@attendance/shared/schemas/settings';
import { SectionShell } from './SettingsControls.js';

/**
 * The four one-click feature presets — everything on, the lean site
 * deployment, the office-only one, and terminals-only.
 *
 * Its own file because `SettingsPage` is far over its budget and this is the
 * most self-contained thing in it: four buttons, one callback, no state and no
 * query. The presets themselves live in `@attendance/shared` — they decide what
 * a deployment IS, so they are not this screen's to define.
 */
export function FeaturePresets({
  onApply,
}: {
  onApply: (preset: Record<FeatureKey, boolean>) => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <SectionShell
      id="settings-section-presets"
      title={t('settings.s.presets.title')}
      blurb={t('settings.s.presets.blurb')}
    >
      <div className="flex flex-wrap gap-element">
        <Button
          type="button"
          variant="outline"
          size="touch"
          onClick={() => onApply(LEAN_ATTENDANCE_FEATURES)}
        >
          {t('settings.preset.lean')}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="touch"
          onClick={() => onApply(OFFICE_ONLY_FEATURES)}
        >
          {t('settings.preset.officeOnly')}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="touch"
          onClick={() => onApply(TERMINAL_ONLY_FEATURES)}
        >
          {t('settings.preset.terminalOnly')}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="touch"
          onClick={() => onApply(FEATURE_DEFAULTS)}
        >
          {t('settings.preset.full')}
        </Button>
      </div>
    </SectionShell>
  );
}
